import React from "react";
import "./contact.css";
import {Grid, Button, Image} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import {data, useWindowWidth} from "artcode-tool";
import AnchorLink from 'react-anchor-link-smooth-scroll'

// function 

function Contact(){
    let width = useWindowWidth();

    function infoDesktop(width, data){
        return <Grid className="info">
        <Grid.Row className="info-column middle align" columns={(width < data.widthResponsive)?1:3}>
            <Grid.Column width={(width < data.widthResponsive)?12:6}>
            <p><strong>Artefield, Comunicação Visual</strong></p>
            <p>Rua Ceará, 247 - São Paulo, Brasil</p>
            <p>Email: contato@artefield.com.br</p>
            </Grid.Column>
            <Grid.Column className="social-max-width" width={(width < data.widthResponsive)?6:4}>
                <Grid>
                    <Grid.Row columns={3}>
                        <Grid.Column>
                            <a className="social-align" href="https://www.facebook.com/ArteField1/"><Image src={require("./face.png")}/></a>
                        </Grid.Column>
                        <Grid.Column>
                            <a className="social-align" href="https://www.instagram.com/artefield/"><Image src={require("./insta.png")}/></a>
                        </Grid.Column>
                        <Grid.Column>
                            <a className="social-align" href="https://bit.ly/2IcLQ9D/"><Image src={require("./whats.png")}/></a>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Grid.Column>
            <Grid.Column width={(width < data.widthResponsive)?12:6}>
                <a style={{width: "100%", display: "table", textAlign: "center"}} href="https://artcodeagencia.com" rel="noopener noreferrer" target="_blank">Desenvolvido por Artcode</a>
            </Grid.Column>
            </Grid.Row>
        </Grid>
    }

    function infoMobile(width, data){
        return <Grid className="info">
            <Grid.Row className="info-column middle align" columns={(width < data.widthResponsive)?1:3}>
            <Grid.Column className="social-max-width" width={(width < data.widthResponsive)?6:4}>
            <Grid>
                <Grid.Row columns={3}>
                    <Grid.Column>
                        <a className="social-align" href="https://www.facebook.com/ArteField1/"><Image src={require("./face.png")}/></a>
                    </Grid.Column>
                    <Grid.Column>
                        <a className="social-align" href="https://www.instagram.com/artefield/"><Image src={require("./insta.png")}/></a>
                    </Grid.Column>
                    <Grid.Column>
                        <a className="social-align" href="https://bit.ly/2IcLQ9D/"><Image src={require("./whats.png")}/></a>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Grid.Column>
        <Grid.Column width={(width < data.widthResponsive)?16:6}>
            <p><strong>Artefield, Comunicação Visual</strong></p>
            <p>Rua Ceará, 247 - São Paulo, Brasil</p>
            <p>Email: contato@artefield.com.br</p>
        </Grid.Column>
        <Grid.Column width={(width < data.widthResponsive)?16:6}>
            <a style={{width: "100%", display: "table", textAlign: "center"}} href="https://artcodeagencia.com" rel="noopener noreferrer" target="_blank">Desenvolvido por Artcode</a>
        </Grid.Column>
        </Grid.Row>
        </Grid>
    }

    return (
        <footer>
            <div className="circle circle-yellow"></div>
            <div className="circle circle-pink"></div>
            <div className="whatsapp">
                <p><a href="https://api.whatsapp.com/send?phone=5511958690720" rel="noopener noreferrer"><Button inverted>Clique Aqui</Button></a><span>para fazer seu orçamento via WhatsApp</span></p>
            </div>
            <div className="coupon">
                <AnchorLink href="#contato"><Button color="orange">Ganhe 5% de desconto</Button></AnchorLink>
            </div>
            <div className="info-align">
                <div className="info-align-column">
                    {(width > data.widthResponsive)? infoDesktop(width, data):infoMobile(width, data)} 
                </div>
             </div>
        </footer>
    );
}

export default (Contact);